// extracted by mini-css-extract-plugin
export default {"img":"animated_img__WXT5u"};